export default __webpack_public_path__ + "static/media/westfield-w.inline.e70a405e.svg";